module.exports = __webpack_public_path__ + "img/introduce.fe3d0a6e.png";